import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['realInputName', 'realInputFields', 'hours', 'mins', 'unit']
  static values = { location: String }
  initialize () {
    this.updateInput()
  }

  updateInput () {
    let hoursInput = ''
    let minsInput = ''

    if (this.hasRealInputFieldsTarget) {
      hoursInput = this.realInputFieldsTarget.querySelector('.hours_input')
      minsInput = this.realInputFieldsTarget.querySelector('.mins_input')
    } else {
      hoursInput = this.getFormField( this.locationValue, `${this.realInputNameTarget.dataset.name}_4i`)
      minsInput = this.getFormField( this.locationValue, `${this.realInputNameTarget.dataset.name}_5i`)
    }

    if (hoursInput) {
      if (this.unitTarget.checked && this.hoursTarget.value !== '12') {
        hoursInput.value = String(parseInt(this.hoursTarget.value) + 12)
      } else if (
        !this.unitTarget.checked &&
        parseInt(this.hoursTarget.value) === 12
      ) {
        hoursInput.value = '00'
      } else {
        hoursInput.value = this.hoursTarget.value
      }
    }

    if (minsInput) {
      minsInput.value = this.minsTarget.value
    }
  }

  getFormField (location, name) {
    if (location == 'create-modal') {
      return document.getElementById('create-task').querySelector(`#${name}`)
    } else if (location == 'edit-modal') {
      return document.getElementById('edit-task').querySelector(`#${name}`)
    } else if (location != '' && location != null && location != 'default') {
      return document.getElementById(location).querySelector(`#${name}`)
    } else {
      return document.getElementById(name)
    }
  }

  // Set default minutes to '00' when hour changes and minutes field is empty, set complete field to blank if any field is empty
  setDefaultValue(event) {
    if (event.currentTarget == this.hoursTarget) {
      if (this.minsTarget.value == '' && this.hoursTarget.value != '') { this.minsTarget.value = '00' }
      if (this.hoursTarget.value == '') { this.minsTarget.value = '' }
    } else {
      if (this.minsTarget.value == '') { this.hoursTarget.value = '' }
    }

    this.updateInput()
  }
}
